import deviceApi from '@/api/device.js'

export const resetState = ({ commit }) => {
  commit('resetState')
}

export const load = ({ commit }, groupId) => {
  return deviceApi.get(groupId).then(data => {
    commit('setDevices', data.devices)
    commit('setTotalInstalls', data.total_installs)
    commit('setUsedInstalls', data.used_installs)

    return data.devices
  })
}

export const remove = ({ commit }, deviceId) => {
  return deviceApi.remove(deviceId).then(() => {
    commit('removeDevice', deviceId)
    commit('children/removeChildDevice', deviceId, { root: true })
  })
}
